function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "pound");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M0,21.49H3.91a10.39,10.39,0,0,0,1.35-4.72A16.52,16.52,0,0,0,5,14H1V12.18H4.59L3.74,10a11.41,11.41,0,0,1-.87-4.11C2.87,2.53,5.33,0,9.11,0a6.15,6.15,0,0,1,5.7,2.94L13.36,4.35A4.52,4.52,0,0,0,9.24,2,3.67,3.67,0,0,0,5.3,5.8,10.63,10.63,0,0,0,6.24,10L7,12.18h5.13V14H7.42a14.48,14.48,0,0,1,.31,2.77,11,11,0,0,1-1.35,4.72h9.14v2.13H0Z"
})));

var SvgGbp = function SvgGbp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.52 23.62",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGbp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gbp.196f1f27.svg";
export { ForwardRef as ReactComponent };